import { Dispatch } from "react";
import axios, { AxiosResponse } from "axios";
import { AnyIfEmpty } from "react-redux";
import { GET_ROLES_LIST_FAILURE, GET_ROLES_LIST_REQUEST, GET_ROLES_LIST_SUCCESS } from "../constants/roles.constant";

const getRolesListSuccess = (roleList: AnyIfEmpty<object>) => {
    return {
        type: GET_ROLES_LIST_SUCCESS,
        payload: roleList,
    };
};

const getRolesListFailure = (error: AnyIfEmpty<object>) => {
    return {
        type: GET_ROLES_LIST_FAILURE,
        payload: error,
    };
};

const getRolesListRequest = () => {
    return {
        type: GET_ROLES_LIST_REQUEST,
    };
};


export const getRolesList = (searchText: string | null) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getRolesListRequest());
        axios.get('/roles', {
            headers: { 'x-internal-api': 'true' }, params: { searchText: searchText }
        })
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    dispatch(getRolesListSuccess(response?.data?.roles));
                } else {
                    dispatch(getRolesListFailure(response?.data?.message))
                }
            })
            .catch((error) => dispatch(getRolesListFailure(error?.response?.data?.message)));
    };
};

export const createNewRole = (name: string, description: string, onSuccess: (message: string) => void, onFailure: (message: string) => void) => {
    return () => {
        axios.post('/roles', { name: name, description: description })
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 201) {
                    onSuccess(response?.data?.message)
                } else {
                    onFailure(response?.data?.message)
                }
            }).catch((error) => onFailure(error?.response?.data?.message));
    };
};

export const updateRole = (id: string, name: string, description: string, onSuccess: (message: string) => void, onFailure: (message: string) => void) => {
    return () => {
        axios.patch(`/roles/${id}`, { name: name, description: description })
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    onSuccess(response?.data?.message)
                } else {
                    onFailure(response?.data?.message)
                }
            }).catch((error) => onFailure(error?.response?.data?.message));
    };
};

export const deleteRole = (id: string, onSuccess: (message: string) => void, onFailure: (message: string) => void) => {
    return () => {
        axios.delete(`/roles/${id}`)
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    onSuccess(response?.data?.message)
                } else {
                    onFailure(response?.data?.message)

                }
            }).catch((error) => onFailure(error?.response?.data?.message));
    };
};